// ── Welle K5: Rahmen der Einstellungen ───────────────────────────────────────────
// Ein Bereich zeigt seinen Speichern-Knopf am Handy oben rechts (neben „‹ Einstellungen“),
// am PC unten rechts im Bereich. Die Bereiche rufen dafür <EinstSpeichern> auf — der Knopf
// wird per Portal in die Kopfzeile gesetzt, wenn es sie gibt. Speicherwege bleiben unverändert.
import React, { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';
import { MIcon } from '../../lib/micon';

export const EinstSpeichernZiel = createContext<HTMLElement | null>(null);

export function EinstSpeichern({ onClick, laden = false, aus = false, children = 'Speichern', hinweis }: {
  onClick: () => void; laden?: boolean; aus?: boolean; children?: React.ReactNode; hinweis?: React.ReactNode;
}) {
  const ziel = useContext(EinstSpeichernZiel);
  const knopf = (
    <button type="button" className="ld-fe-knopf ld-fe-knopf--haupt ld-es-speichern" onClick={onClick} disabled={aus || laden}>
      {laden ? 'Bitte warten …' : children}
    </button>
  );
  if (ziel) return <>{hinweis && <p className="ld-es-fuss__hinweis"><MIcon name="info" size={17} />{hinweis}</p>}{createPortal(knopf, ziel)}</>;
  return (
    <div className="ld-es-fuss">
      {hinweis && <p className="ld-es-fuss__hinweis"><MIcon name="info" size={17} />{hinweis}</p>}
      {knopf}
    </div>
  );
}

/** Zeile in einem Bereich: Titel, Unterzeile, rechts ein Element (Schalter, Knopf, Wert) */
export function EinstZeile({ titel, text, rechts, gefahr = false }: {
  titel: React.ReactNode; text?: React.ReactNode; rechts?: React.ReactNode; gefahr?: boolean;
}) {
  return (
    <div className="ld-es-zeile">
      <div className="ld-es-zeile__text">
        <b className={gefahr ? 'ist-gefahr' : undefined}>{titel}</b>
        {text && <span>{text}</span>}
      </div>
      {rechts && <div className="ld-es-zeile__rechts">{rechts}</div>}
    </div>
  );
}

/** Kleiner Schalter (sofort speichern) */
export function EinstSchalter({ an, onChange, label, aus = false }: { an: boolean; onChange: () => void; label: string; aus?: boolean }) {
  return (
    <button type="button" role="switch" aria-checked={an} aria-label={label} disabled={aus}
      className={`ld-es-schalter${an ? ' ist-an' : ''}`} onClick={onChange}><i /></button>
  );
}

/** Abschnitt in einem Bereich (Untertitel + Inhalt) */
export function EinstAbschnitt({ titel, children }: { titel?: React.ReactNode; children: React.ReactNode }) {
  return (
    <section className="ld-es-abschnitt">
      {titel && <h3>{titel}</h3>}
      {children}
    </section>
  );
}
